// @arch:pure-engine
// Bounded append-only journal for a run. The renderer may project it into UI,
// while a future supervisor can persist the same event contract externally.

const DEFAULT_LIMIT = 512;

export function createRunJournal(limit = DEFAULT_LIMIT) {
  const max = Number.isFinite(limit) && limit > 0 ? Math.floor(limit) : DEFAULT_LIMIT;
  const events = [];
  let sequence = 0;

  function append(type, payload = {}, at = Date.now()) {
    const event = Object.freeze({
      id: `${at}-${++sequence}`,
      type,
      at,
      payload: Object.freeze({ ...(payload || {}) }),
    });
    events.push(event);
    if (events.length > max) events.splice(0, events.length - max);
    return event;
  }

  return {
    append,
    snapshot: () => events.slice(),
    replay: (consumer) => events.forEach(consumer),
    clear: () => { events.length = 0; },
  };
}

export function reduceRunEvents(events = []) {
  return events.reduce((state, event) => {
    if (!event || typeof event.type !== 'string') return state;
    if (event.type === 'run_started') return { ...state, status: 'running', startedAt: event.at };
    if (event.type === 'run_finished') return { ...state, status: 'done', finishedAt: event.at };
    if (event.type === 'run_failed') return { ...state, status: 'failed', error: event.payload?.error || null, finishedAt: event.at };
    if (event.type === 'run_cancelled') return { ...state, status: 'cancelled', finishedAt: event.at };
    if (event.type === 'message_appended') return { ...state, messageCount: (state.messageCount || 0) + 1 };
    return state;
  }, { status: 'queued', messageCount: 0 });
}
